'use client'
import Tool from './Tool'
import HeaderTool from './HeaderTool'
import { useState } from 'react'
import { Menu, MessageCircle } from 'lucide-react'
import GroupShare from '../blog/GroupShare'
import React from 'react'
import { Drawer, DrawerContent, DrawerHeader, DrawerTitle, DrawerTrigger } from '~/components/ui/drawer'
import CommentForm from '../comments/CommentForm'
import dynamic from 'next/dynamic'
import SkeletonComments from '../comments/Skelecton'
import { Badge } from '../ui/badge'

const Comments = dynamic(() => import('../comments'), { ssr: false, loading: () => <SkeletonComments /> })

type NameTool = 'tableOfContents' | 'bookmark' | 'comment' | '' | 'share'

const dataTools: {
    id: string
    name: string
    icon: React.FC
    nameTool: NameTool
    notify?: number
}[] = [
    {
        id: '1',
        name: 'Nội dung',
        icon: Menu,
        nameTool: 'tableOfContents'
    }
    // {
    //     id: '2',
    //     name: 'Đánh dấu',
    //     icon: 'mage:bookmark',
    //     nameTool: 'bookmark',
    //     notify: 3
    // },
    // {
    //     id: '4',
    //     name: 'Chia sẻ',
    //     icon: Share2,
    //     nameTool: 'share'
    // }
]

type ToolType = {
    nameTool: NameTool
    title: string
}

const toolDefault: ToolType = {
    nameTool: '',
    title: ''
}

type ToolsProps = {
    elementTableOfContent?: React.ReactNode
    slug: string
    isAuth?: boolean
    blogId: string
    commentCount?: number
}

const Tools = ({ elementTableOfContent, slug, isAuth, blogId, commentCount }: ToolsProps) => {
    const [tool, setTool] = useState<ToolType>(toolDefault)
    const handleTool = (name: NameTool) => () => {
        const result = dataTools.find((dataTool) => dataTool.nameTool === name)
        setTool({
            nameTool: result?.nameTool ?? '',
            title: result?.name ?? ''
        })
    }
    const closeTool = () => {
        setTool(toolDefault)
    }
    return (
        <>
            <div className='absolute bottom-full mb-4 w-full max-w-(--breakpoint-md) overflow-hidden rounded-2xl border-neutral-200 bg-neutral-100 dark:border-neutral-800 dark:bg-neutral-900'>
                {tool.nameTool !== '' && (
                    <div className='overflow-y-auto bg-neutral-100 dark:bg-neutral-900'>
                        <HeaderTool name={tool.title} onClose={closeTool} />
                        <div className='max-h-96 py-0'>
                            {tool.nameTool === 'tableOfContents' && elementTableOfContent}
                            {tool.nameTool === 'share' && (
                                <div className='mx-4 mb-2'>
                                    <GroupShare />
                                </div>
                            )}
                        </div>
                    </div>
                )}
            </div>
            <div className='inline-flex rounded-full border border-neutral-200 bg-neutral-100 p-0.5 px-2 shadow-md dark:border-neutral-800 dark:bg-neutral-900'>
                {dataTools.map((dataTool) => (
                    <Tool
                        key={dataTool.id}
                        onClick={handleTool(dataTool.nameTool as NameTool)}
                        Icon={dataTool.icon}
                        notify={dataTool.notify}
                    />
                ))}
                <Drawer>
                    <DrawerTrigger className='relative flex items-center gap-1 p-1.5'>
                        <MessageCircle className='size-4' />
                        <span className='text-xs text-red-500 dark:text-foreground'>{commentCount ?? 0}</span>
                    </DrawerTrigger>
                    <DrawerContent className='mx-auto h-[90vh] max-w-(--breakpoint-md) bg-neutral-100 dark:bg-neutral-900'>
                        <DrawerHeader className='mt-2 py-1 sm:mt-0'>
                            <DrawerTitle className='text-base'>Bình luận</DrawerTitle>
                        </DrawerHeader>
                        <div className='flex h-full flex-col'>
                            <div className='flex-1 overflow-auto px-4 pb-16'>
                                {isAuth && <Comments slug={slug} />}
                                {!isAuth && (
                                    <p className='mt-6 text-center text-sm'>Vui lòng đăng nhập xem bình luận</p>
                                )}
                            </div>
                            {isAuth && <CommentForm slug={slug} blogId={blogId} isMobile />}
                        </div>
                    </DrawerContent>
                </Drawer>
            </div>
        </>
    )
}

export default Tools
